import { MedicalVisitOpinionEnum } from '@geartracker/types';

import { createZodDto } from './zod';

import { z } from 'zod';

export const CreateUpdateMedicalVisitSchema = z
  .object({
    typeId: z.number().int(),
    userId: z.number().int(),
    // Effective date the visit took place, not a scheduled appointment —
    // must not be in the future or it would prematurely satisfy compliance.
    date: z.coerce.date(),
    opinion: z.nativeEnum(MedicalVisitOpinionEnum),
    restriction: z.string().nullable(),
    filesIds: z.number().array().default([]),
  })
  .refine((data) => data.date <= new Date(), {
    message: 'Visit date cannot be in the future',
    path: ['date'],
  })
  // A physician's "fit with restrictions" or "unfit" opinion is only
  // meaningful together with what it actually restricts/recommends —
  // see L4624-6 (fit with restrictions) and L4624-4 (unfit) of the French
  // labor code.
  .refine(
    (data) =>
      data.opinion === MedicalVisitOpinionEnum.APTE ||
      !!data.restriction?.trim(),
    {
      message: 'Operational restriction is required when opinion is not APTE',
      path: ['restriction'],
    },
  );

export class MedicalVisitCreateUpdateDto extends createZodDto(
  CreateUpdateMedicalVisitSchema,
) {}
